import { isObject } from "./isObject";

export const empty = function(el) {
  if (
    el === "" ||
    el === 0 ||
    el === null ||
    el === false ||
    typeof el === "undefined" ||
    (Array.isArray(el) && el.length === 0) ||
    (isObject(el) && Object.keys(el).length === 0 && el.constructor === Object)
  )
    return true;
  return false;
};
